import styled from "styled-components"

type StyledProps = {
  $selected?: boolean
  $orderPercentage?: boolean
}

export const OrderPercentageContainer = styled.div`
  margin: 2rem 0;
  padding-bottom: 2rem;
  border-bottom: 0.1rem solid ${(p) => p.theme.colors.greyLight};
  b {
    font-size: 1.2rem;
  }
`

export const PercentageButtonWrapper = styled.div<StyledProps>`
  display: flex;
  padding-top: 0.5rem;
  justify-content: flex-start;
  grid-template-columns: 1fr 1fr 1fr;
  max-height: 9rem;
  gap: 0.5rem;

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  input[type="number"] {
    -moz-appearance: textfield;
  }
`

export const Amount = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

export const InputPercentage = styled.input`
  border-radius: 0.6rem;
  border: 0.1rem solid ${(p) => p.theme.colors.greyLight};
  width: 4.5rem;
  height: 3rem;
  padding: 0 1rem;
`

export const PercentageButton = styled.div<StyledProps>`
  background: ${(p) =>
  p.$orderPercentage && p.$selected
    ? p.theme.colors.greyDark
    : p.$selected
      ? p.theme.colors.turquoiseDark
      : p.theme.colors.white};
  color: ${(p) => (p.$selected ? p.theme.colors.white : p.theme.colors.black)};
  border: 0.1rem solid
    ${(p) =>
  p.$orderPercentage && p.$selected
    ? p.theme.colors.greyLight
    : p.$selected
      ? p.theme.colors.turquoiseDark
      : p.theme.colors.greyLight};
  font-weight: ${(p) => (p.$selected ? "bold" : "normal")};
  border-radius: 0.6rem;
  width: 4.5rem;
  height: 3rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2rem;

  &:hover {
    cursor: pointer;
    background-color: ${(p) => p.theme.colors.turquoiseDark};
    color: ${(p) => p.theme.colors.white};
  }
`


